import { render, staticRenderFns } from "./tagview.vue?vue&type=template&id=597168bb&scoped=true&"
import script from "./tagview.vue?vue&type=script&lang=js&"
export * from "./tagview.vue?vue&type=script&lang=js&"
import style0 from "./tagview.vue?vue&type=style&index=0&id=597168bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597168bb",
  null
  
)

export default component.exports